"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Icon = _interopRequireDefault(require("@mulesoft/anypoint-icons/lib/Icon"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var defaultProps = {
  option: {},
  onSelect: function onSelect() {},
  onFocus: function onFocus() {}
};
var Option = exports["default"] = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(Option, _React$Component);
  function Option() {
    var _this;
    (0, _classCallCheck2["default"])(this, Option);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Option, [].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onFocus", function (event) {
      /** Can not reproduce need extra check */
      // if (!this.props.isFocused) {
      //  this.props.onFocus(this.props.option, event);
      // }
      _this.props.onFocus(_this.props.option, event);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "blockEvent", function (event) {
      event.preventDefault();
      event.stopPropagation();
      if (event.target.tagName !== 'A' || !('href' in event.target)) {
        return;
      }
      if (event.target.target) {
        window.open(event.target.href, event.target.target);
      } else {
        window.location.href = event.target.href;
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleMouseDown", function (event) {
      event.preventDefault();
      event.stopPropagation();
      _this.props.onSelect(_this.props.option, event);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleMouseEnter", function (event) {
      _this.onFocus(event);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleMouseMove", function (event) {
      _this.onFocus(event);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleTouchEnd", function (event) {
      // Check if the view is being dragged, In this case
      // we don't want to fire the click event (because the user only wants to scroll)
      if (_this.dragging) return;
      _this.handleMouseDown(event);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleTouchMove", function () {
      // Set a flag that the view is being dragged
      _this.dragging = true;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleTouchStart", function () {
      // Set a flag that the view is not being dragged
      _this.dragging = false;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getChildrenOrWrapper", function () {
      var children = _this.props.children;
      if (typeof children === 'string') {
        return /*#__PURE__*/_react["default"].createElement("span", {
          title: children,
          className: "option-label"
        }, children);
      }
      return children;
    });
    return _this;
  }
  (0, _createClass2["default"])(Option, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        option = _this$props.option,
        instancePrefix = _this$props.instancePrefix,
        isSelected = _this$props.isSelected,
        optionIndex = _this$props.optionIndex,
        testId = _this$props.testId;
      var className = (0, _classnames["default"])(this.props.className, option.className);
      if (option.disabled) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          // eslint-disable-line
          className: className,
          onMouseDown: this.blockEvent,
          onClick: this.blockEvent,
          "data-test-id": testId,
          "data-anypoint-component": Option.displayName
        }, this.props.children);
      }
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: className,
        style: option.style,
        role: "option",
        "aria-selected": String(isSelected),
        onMouseDown: this.handleMouseDown,
        onMouseEnter: this.handleMouseEnter,
        onMouseMove: this.handleMouseMove,
        onTouchStart: this.handleTouchStart,
        onTouchMove: this.handleTouchMove,
        onTouchEnd: this.handleTouchEnd,
        id: "".concat(instancePrefix, "-option-").concat(optionIndex),
        "data-test-id": testId,
        "data-anypoint-component": Option.displayName,
        title: option.title
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "option-icon"
      }, isSelected ? /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
        name: "check-small",
        size: "xs",
        className: option.iconClassName
      }) : null), /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, this.getChildrenOrWrapper()));
    }
  }]);
  return Option;
}(_react["default"].Component);
(0, _defineProperty2["default"])(Option, "defaultProps", defaultProps);
(0, _defineProperty2["default"])(Option, "displayName", 'Option');
//# sourceMappingURL=Option.js.map